// extracted by mini-css-extract-plugin
export default {"mainSection":"styles_mainSection__TEeAd","loginForm":"styles_loginForm__kLVKA","loginInput":"styles_loginInput__1lpbL","buttonBlue":"styles_buttonBlue__Qb6C-"};